<template>
  <el-card class="vue-routers-index">
    <template #header>
      <content-header />
    </template>

    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="6" />
      <el-col :span="6"><strong>扫描二维码，直接授权总部代理</strong></el-col>
      <el-col :span="6" />
    </el-row>

    <el-row type="flex" justify="center">
      <div id="qrcode" />
    </el-row>
  </el-card>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'ApplyAllAgent',
  components: {},
  methods: {
    qrcode() {
      const qrcode = new QRCode('qrcode', {
        width: 300,
        height: 300, // 高度
        text: 'http://testm.shengtanggj.cn//applyAllAgent', // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
        correctLevel: QRCode.CorrectLevel.M, // 容错率，L/M/H
      })
      console.log(qrcode)
    },
  },
  mounted() {
    this.qrcode()
  },
}
</script>

<style lang="scss" scoped>
.row-bg {
  padding: 15px;
}
</style>
